import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en.json';
import translationTR from './locales/tr.json';

const resources = {
  en: {
    translation: translationEN
  },
  tr: {
    translation: translationTR
  }
};

// Get initial language:
// 1. First check localStorage (user's saved preference)
// 2. If not found, detect browser language
// 3. If browser language not supported, fallback to English
const savedLanguage = localStorage.getItem('language');
const browserLanguage = navigator.language.split('-')[0]; // Get language code (e.g., 'en' from 'en-US')
const supportedLanguages = ['en', 'tr'];

let initialLanguage;
if (savedLanguage) {
  initialLanguage = savedLanguage;
} else if (supportedLanguages.includes(browserLanguage)) {
  initialLanguage = browserLanguage;
} else {
  initialLanguage = 'en'; // Fallback to English
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false // Disable suspense to avoid issues with lazy loading
    }
  });

export default i18n;
